import React from "react";
import clsx from "clsx";
import "./chat-box-view-header.styles.scss";
import { Avatar } from "../Avatar";
import { Flipped } from "react-flip-toolkit";

//@ts-ignore
import { ReactComponent as SearchIcon } from "../../../assets/icons/Search.svg";
//@ts-ignore
import { ReactComponent as PhoneIcon } from "../../../assets/icons/Phone.svg";
//@ts-ignore
import { ReactComponent as ZaviIcon } from "../../../assets/icons/Zavi.svg";
//@ts-ignore
import { ReactComponent as SidebarIcon } from "../../../assets/icons/Sidebar.svg";

import { useChatBoxViewContext } from "../../contexts";
import { useChatBoxWindowInfo } from "../../components/ChatBoxWindow";

export interface ChatBoxViewHeaderProps {
	className?: string;
}

const BlockName = "chat-box-view-header";
const ClassNames = {
	Block: BlockName,
	Modifiers: {},
	Elements: {
		Avatar: `${BlockName}__avatar`,
		HeaderTitle: `${BlockName}__header-title`,
		HeaderSubtitle: `${BlockName}__header-subtitle`,
		HeaderButton: `${BlockName}__header-button`,
	},
} as const;

export type ChatBoxViewHeaderComponent = React.FC<ChatBoxViewHeaderProps> & {
	ClassNames: typeof ClassNames;
};

export const ChatBoxViewHeader = ((props: ChatBoxViewHeaderProps) => {
	const { toUidInfo } = useChatBoxViewContext();
	const { id: windowId } = useChatBoxWindowInfo();

	return (
		<header className={clsx(ChatBoxViewHeader.ClassNames.Block, props.className)}>
			<div className="flex items-center gap-2">
				{/* @note: disable flip for avatar (fix temporary). */}
				<Flipped flipId={`cbw-avatar-w${windowId}`} shouldFlip={() => false}>
					<Avatar
						id={`#cbv-header-avatar-w${windowId}`}
						className={ChatBoxViewHeader.ClassNames.Elements.Avatar}
						size={48}
						alt={toUidInfo.name}
						src={toUidInfo.avatarUrl}
					/>
				</Flipped>

				<div className="flex flex-col truncate">
					<h3
						className={clsx(
							ChatBoxViewHeader.ClassNames.Elements.HeaderTitle,
							"truncate",
						)}
					>
						{toUidInfo.name}
					</h3>
					<p
						className={clsx(
							ChatBoxViewHeader.ClassNames.Elements.HeaderSubtitle,
							"truncate",
						)}
					>
						{toUidInfo.accessTimeInfo}
					</p>
				</div>
			</div>

			<div className="flex items-center gap-2">
				<button className={ChatBoxViewHeader.ClassNames.Elements.HeaderButton}>
					<SearchIcon className="w-6 h-6 text-gray-800" />
				</button>
				<button className={ChatBoxViewHeader.ClassNames.Elements.HeaderButton}>
					<PhoneIcon className="w-6 h-6 text-gray-800" />
				</button>
				<button className={ChatBoxViewHeader.ClassNames.Elements.HeaderButton}>
					<ZaviIcon className="w-6 h-6 text-gray-800" />
				</button>
				<button className={ChatBoxViewHeader.ClassNames.Elements.HeaderButton}>
					<SidebarIcon className="w-6 h-6 text-gray-800" />
				</button>
			</div>
		</header>
	);
}) as ChatBoxViewHeaderComponent;

ChatBoxViewHeader.ClassNames = ClassNames;
